<template>
  <form @submit.prevent="onsubmit" class="login">
    <div class="row mb-2">
      <va-input
        v-model="email"
        type="email"
        :label="$t('auth.email')"
        :error="!!emailErrors.length"
        :error-messages="emailErrors"
      />
    </div>
    <div class="row justify--center">
      <va-button type="submit" class="my-0">{{ $t('auth.reset_password') }}</va-button>
    </div>
  </form>
</template>

<script>
import * as firebase from 'firebase/app'
import 'firebase/auth'

export default {
  name: 'recover-password',
  data () {
    return {
      email: '',
      emailErrors: [],
    }
  },
  methods: {
    async onsubmit () {
      if (!this.email) {
        this.emailErrors = ['Email is required']
      } else {
        try {
          var result = await firebase.auth().sendPasswordResetEmail(this.email)
          console.log(result)
        } catch (error) {
          this.showToast(error.message, {
            icon: 'fa-exclamation',
            position: 'bottom-right',
            duration: 5000,
          })
        }
        this.$router.push('login')
      }
    },
  },
}
</script>

<style lang="scss">
</style>
